// Extract unique filter values from reminder data
export const extractFilterValues = (data) => {
  const categories = [...new Set(data.map((reminder) => reminder.category))].sort()
  const departments = [...new Set(data.map((reminder) => reminder.department))].sort()
  const priorities = ['Critical', 'High', 'Medium', 'Low']

  return {
    categories,
    departments,
    priorities
  }
}

// Apply filters to reminder data
export const applyFilters = (data, filters) => {
  const { searchText, categoryFilter, priorityFilter, acknowledgedFilter } = filters

  return data.filter((reminder) => {
    // Text search
    const textMatch =
      searchText === '' ||
      reminder.reminderTitle.toLowerCase().includes(searchText.toLowerCase()) ||
      reminder.staffName.toLowerCase().includes(searchText.toLowerCase()) ||
      reminder.reminderId.toLowerCase().includes(searchText.toLowerCase()) ||
      (reminder.reminderDetails && reminder.reminderDetails.toLowerCase().includes(searchText.toLowerCase()))

    // Category filter
    const categoryMatch = categoryFilter === 'all' || reminder.category === categoryFilter

    // Priority filter
    const priorityMatch = priorityFilter === 'all' || reminder.priority === priorityFilter

    // Acknowledged filter
    const acknowledgedMatch =
      acknowledgedFilter === 'all' ||
      (acknowledgedFilter === 'acknowledged' && reminder.isAcknowledged) ||
      (acknowledgedFilter === 'unacknowledged' && !reminder.isAcknowledged)

    return textMatch && categoryMatch && priorityMatch && acknowledgedMatch
  })
}

// Split filtered data by date (upcoming vs past)
export const splitByDate = (filteredData) => {
  const today = new Date()
  const upcomingReminders = filteredData.filter((reminder) => new Date(reminder.reminderDate) >= today)
  const pastReminders = filteredData.filter((reminder) => new Date(reminder.reminderDate) < today)

  return {
    upcomingReminders,
    pastReminders
  }
}
